<template>
  <!-- class="status_check fixed-bottom has-text-centered" -->
  <div
      class="draggable-image"
      :style="{ bottom: position.y + 'px', right: position.x + 'px' }"
      @click="statusCheck()"


  >
    <div class="is-flex is-justify-content-center">
      <img
          src="../assets/images/icons/Blue/Status_check.png"
          alt="Status_check.image"
          class="status_check_image mb-0 pb-0"
      />
    </div>
    <p
        class="specific-sentance mt-0 pt-0 is-size-7-mobile statusCheckText"
        style="letter-spacing: 0.6px; line-height: 11px;"
    >
      Status Check
    </p>
  </div>
</template>

<script>
export default {
  data(){
    return{
      isDragging: false,
      position: { x: 20, y: 140 },
      startPosition: { x: 0, y: 0 },
    }

  },
  methods: {
    statusCheck(){
    this.$router.push("enter-name");
  }
}


}



</script>

<style scoped>
.draggable-image {
  position: fixed;
  cursor: pointer;
  z-index: 100 !important;
}

.draggable-image img {
  /* display: block; */
  width: 50px;
  margin: auto;
}
.statusCheckText{
  color: #ffffff;
}
@media (max-width: 500px) {

  .statusCheckText {
    color: #000000;
  }
}

</style>